module.exports = __webpack_public_path__ + "img/cuisine.795e096a.svg";